import { render, staticRenderFns } from "./aboutuser.vue?vue&type=template&id=4e905b35&scoped=true"
import script from "./aboutuser.vue?vue&type=script&lang=js"
export * from "./aboutuser.vue?vue&type=script&lang=js"
import style0 from "./aboutuser.vue?vue&type=style&index=0&id=4e905b35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e905b35",
  null
  
)

export default component.exports